import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CART_URL } from './constants';
import { trackAddToCart } from '../utils/metaPixel';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  size?: 'md' | 'lg';
}
export function CTAButton({
  children,
  className = '',
  size = 'lg'
}: CTAButtonProps) {
  const sizes = size === 'lg' ? 'px-8 py-4 text-base sm:text-lg' : 'px-6 py-3 text-sm sm:text-base';
  return <a href={CART_URL} onClick={trackAddToCart} className={`group inline-flex items-center justify-center gap-2 rounded-full bg-coral font-semibold text-white shadow-soft transition-all duration-300 hover:bg-coral-dark hover:-translate-y-0.5 hover:shadow-[0_24px_60px_-16px_rgba(213,90,65,0.6)] focus:outline-none focus-visible:ring-4 focus-visible:ring-coral-light/60 ${sizes} ${className}`} data-id="element-33" data-mp="2tx9u6jbqpe1e">
      <span data-id="element-34" data-mp="38o901ml6xoha">{children}</span>
      <ArrowRightIcon className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1" data-id="element-35" data-mp="38p1y7z6335nt" />
    </a>;
}